import ShopifyVariant from "./ShopifyVariant";
import PriceRange from "./PriceRange";
import Image from "./Image";
import Media from "./Media";
import SellingPlanGroup from "./SellingPlanGroup";
export default class ShopifyProduct {
  id?: string;
  description?: string;
  title: string;
  title2?: string;
  handle?: string;
  images: Image[] = [];
  productVariants: ShopifyVariant[] = [];
  priceRange!: PriceRange;
  availableForSale!: boolean;
  media: Media[] = [];
  tags: string[] = [];
  order: number = 1000;
  productType: string = "";
  collections: any[] = [];
  variant: any = {};
  sellingPlanGroups: any[] = [];

  constructor(response?: any) {
    const {
      id,
      title,
      variant,
      handle,
      availableForSale,
      priceRange,
      images,
      collections,
      variants,
      media,
      tags,
      productType,
      sellingPlanGroups
    } = response || {};
    this.id = id;
    this.title = title;
    this.variant = variant;
    this.handle = handle;
    this.availableForSale = availableForSale;
    this.priceRange = new PriceRange(priceRange);
    this.images = (images?.edges || []).map(({ node }: any) => new Image(node));
    this.collections = (collections?.edges || []).map(({ node }: any) => ({
      id: node.id,
      title: node.title
    }));
    this.productVariants = (variants?.edges || []).map(({ node }: any) => {
      return new ShopifyVariant(node);
    });
    this.media = (media?.edges || []).map(({ node }: any) => new Media(node));
    this.tags = tags;
    this.productType = productType;
    this.sellingPlanGroups = (sellingPlanGroups?.edges || []).map(
      ({ node }: any) => {
        return new SellingPlanGroup(node);
      }
    );
  }
}
